<template>
	<div id="app">
		<vue-snotify></vue-snotify>
		<nav-header></nav-header>

		<!-- content -->
		<router-view style="margin: 120px auto"/>

		<!-- footer -->
		<b-navbar toggleable="md" type="light" variant="light" fixed='bottom' class="d-none d-md-block" >
		<b-navbar-brand href="https://www.unil.ch/bix"  tag='h4'>© UNIL &amp; EPFL {{year}}</b-navbar-brand>
		<p class = 'text-center' style = "width: 100%; padding-top: 0.32421875rem" v-if="user.username && path==='timesheet'"><code><b>HELP:</b> SHIFT "+" to create a new task (today) | drag-drop a task to change day | SHIFT (or ALT) drag-drop to clone a task</code></p>
	</b-navbar>

</div>
</template>


<script>

import navHeader from '@/components/navheader'
import { mapGetters } from 'vuex'
export default {
	components: { navHeader },
	name: 'App',
	data () {
		return {
			path: "/"
		}
	},
	computed:{
		...mapGetters({
			user: 'currentUser'
		}),
		year () {
			return new Date().getFullYear();
		},
	},
	created () {
		document.title = "BIƆC";
		const tag = document.createElement('meta')
		tag.setAttribute('name','robots')
		tag.setAttribute('content','none')
		document.head.appendChild(tag)
	},
	watch:{
		'$route' (to){
			this.path = to.name
		}
	}
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
/*  text-align: center;*/
  color: #2c3e50;
}

#app .btn-xs{
	cursor:pointer;
	padding: 0.2rem 0.4rem;
  font-size: 0.8rem;
  line-height: 1.7;			
}
#app .nowrap{
	white-space:nowrap;		
}

.pointer{
	cursor:pointer;
}
.ban{
	cursor:not-allowed;
}

.uppercase{
	text-transform:uppercase;
}

.has-error{
	color:#dc3545;
}
.has-error input{
	border:1px solid #dc3545 !important;
}
.has-error input:focus{
	border:1px solid #dc3545;
	box-shadow:0 0 0 0.15rem #F8E6E0 !important;
}
.has-error select{
	border:1px solid #dc3545 !important;
}
.has-error select:focus{
	border:1px solid #dc3545;
	box-shadow:0 0 0 0.15rem #F8E6E0 !important;
}


.has-error small{
	float:left;
	margin-top:5px;
	font-style:italic;
	font-size:11px;
}

a.navbar-brand {
	color: #CCC;
	font-size: 11pt;
}
</style>
